;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Carousel from 'components/ui/Carousel';
import VideoPlayerYT from 'components/ui/VideoPlayerYT';

import { blockRootProps } from 'utils';

import styles from './BlockVideoCarousel.module.scss';

const BlockVideoCarousel = ({
    __typename,
    anchorId,
    videos,
    flushTop,
    flushBottom,
}) => {
    videos ??= [];

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <Carousel slideClassName={styles.slide} className={styles.carousel}>
                {videos.map((video, index) => {
                    return (
                        <div key={index} className={styles.item}>
                            <VideoPlayerYT {...video} index={index} />
                        </div>
                    );
                })}
            </Carousel>
        </div>
    );
};

BlockVideoCarousel.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    className: PropTypes.string,
    videos: PropTypes.arrayOf(PropTypes.shape(VideoPlayerYT.PropTypes)),
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
};

export default BlockVideoCarousel;
